export class ProceduralText
{
  static repeat( source:string, times:number )
  {
    let list = [];

    while ( times > 0 )
    {
      list.push( source );
      times--;
    }

    return list.join( "" );
  }
}